import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';
import { useCompleteOperationModal } from '../context/CompleteOperationModalContext';

const CompleteOperationModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useCompleteOperationModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-outline-light"
        onClick={actions.handleCloseModal}
        disabled={data.isLoading}
      >
        {t('Cancel')}
      </button>
      <button
        type="button"
        className="btn btn-success"
        onClick={actions.handleConfirm}
        disabled={data.isLoading}
      >
        <em className="icon ni ni-check-circle mr-1" />
        {t('Agree')}
      </button>
    </Modal.Footer>
  );
};

export default CompleteOperationModalFooter;
